/*
  Product page behaviour on top of Dawn's product-info / product-form:
  - Mobile sticky add to bag: appears once the main Add to bag scrolls away; its button presses
    the real Add to bag, so Dawn's form, Suit Splitter's validation and the cart drawer all run as normal.
  - Keeps the sticky bar and the "make it a suit" link in step with the selected variant
    (Dawn publishes PUB_SUB_EVENTS.variantChange).
  - FitCore: shows the shopper's saved size for this garment and, if the URL doesn't already name a
    variant, pre-selects it. Uses the same matching as quick add (window.lsSize).
*/
(() => {
  const root = document.querySelector('.ls-pdp');
  if (!root) return;
  const sectionId = root.dataset.section;
  const sizeIndex = Number(root.dataset.lsSizeIndex);
  const money = (cents) => {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    // Pounds show plain (£199.95); other currencies add their code (e.g. $300.00 USD), matching snippets/ls-money
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
    return currency === 'GBP' ? amount : `${amount} ${currency}`;
  };

  /* ---------- Sticky add to bag ---------- */
  const sticky = root.querySelector('[data-ls-sticky]');
  const mainButton = () => document.getElementById(`ProductSubmitButton-${sectionId}`);
  if (sticky && mainButton()) {
    sticky.hidden = false;
    const io = new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', past);
      document.body.classList.toggle('ls-sticky-atc-on', past);
    });
    io.observe(mainButton());
    sticky.querySelector('[data-ls-sticky-add]').addEventListener('click', () => {
      const button = mainButton();
      if (!button || button.disabled) {
        (root.querySelector('variant-selects') || button)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      button.click();
    });
  }

  function onVariant(variant) {
    if (!variant) return;
    const size = sizeIndex >= 0 ? variant.options[sizeIndex] : variant.title;
    if (sticky) {
      const label = sticky.querySelector('[data-ls-sticky-variant]');
      if (label && variant.title !== 'Default Title') label.textContent = `${size} · `;
      sticky.querySelector('[data-ls-sticky-price]').textContent = money(variant.price);
      sticky.querySelector('[data-ls-sticky-add]').textContent = variant.available ? 'Add to bag' : 'Choose size';
    }
    // "Make it a suit": point at the suit in the same size
    const suit = root.querySelector('[data-ls-make-suit]');
    if (suit) {
      try {
        const map = JSON.parse(suit.querySelector('[data-ls-suit-map]').textContent);
        const link = suit.querySelector('[data-ls-suit-link]');
        if (map[size]) link.href = `${link.dataset.suitUrl}?variant=${map[size]}`;
      } catch (e) {}
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event.data.sectionId === sectionId) onVariant(event.data.variant);
    });
  }

  /* ---------- FitCore saved size ---------- */
  const strip = root.querySelector('[data-ls-fitstrip]');
  function sizeInputs() {
    const picker = root.querySelector('variant-selects');
    if (!picker || sizeIndex < 0) return { radios: [], select: null };
    const position = sizeIndex + 1;
    const radios = [...picker.querySelectorAll(`input[type="radio"][name$="-${position}"]`)];
    const select = radios.length ? null : picker.querySelectorAll('select')[sizeIndex] || null;
    return { radios, select };
  }

  function applySavedSize(preselect) {
    if (!strip || !window.lsSize) return;
    const saved = window.lsSize.fitcoreSize(strip.dataset.garment);
    const note = strip.querySelector('[data-ls-fit-saved]');
    if (!saved) return;
    const { radios, select } = sizeInputs();
    const values = radios.length ? radios.map((r) => r.value) : select ? [...select.options].map((o) => o.value) : [];
    const match = values.find((v) => window.lsSize.sameSize(v, saved));
    note.hidden = false;
    note.textContent = match ? `Your FitCore size: ${match}` : `Your FitCore size (${saved}) isn't made in this style`;
    if (!match || !preselect || new URLSearchParams(window.location.search).has('variant')) return;
    if (radios.length) {
      const radio = radios.find((r) => r.value === match);
      if (radio && !radio.checked && !radio.classList.contains('disabled')) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (select && select.value !== match) {
      select.value = match;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  applySavedSize(true);
  window.addEventListener('message', (e) => {
    if (e.data && e.data.type === 'fitcore:result') setTimeout(() => applySavedSize(false), 50);
  });
})();
